/**
 * Helper function to capitalize words
 * @param string word
 * @returns capitalized word
 */
export const capitalize = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Formats a number with commas as thousand separators
 * @param value number or string to format
 * @returns formatted string with commas
 */
export const formatNumber = (value: any): string => {
  if (value == null || value === '') return '-'
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num)) return String(value)
  return num.toLocaleString('en-US', { maximumFractionDigits: 2 })
}

export const prepend = (value: any, array: Array<any>) => {
  var newArray = array.slice()
  newArray.unshift(value)
  return newArray
}
